export default __webpack_public_path__ + "static/media/community.f5505f30.png";